var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","small":"","title":"Imprimir Romaneio"},on:{"click":_vm.print}},[_c('v-icon',[_vm._v(" mdi-printer ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }